import script from "./barChart.vue?vue&type=script&setup=true&lang=js"
export * from "./barChart.vue?vue&type=script&setup=true&lang=js"

import "./barChart.vue?vue&type=style&index=0&id=336f6f6a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336f6f6a"]])

export default __exports__